import { Notification } from '../notification/Notification';
import withErrors from './../../utils/mixins/withError';


var options = {
  closable: true,
  duration: 0,
  style: {right: 10}
};

var ErrorData = React.createClass({

  getInitialState(){
    return {
      expanded: false
    }
  },

  parseErrorContent(errorMessage, errorIndex){
    errorMessage = errorMessage || "";
    return _.map(errorMessage.split('\n'), (msg, index) => (
      <div key={"e-" + errorIndex + "-m-" + index}>{msg}</div>));
  },

  render(){
    var {t} = this.props;
    return (
      <div>
        <p>{t("File imported with some errors. Click")}<span className="notification-link-click" onClick={this.toggle}>here</span>{t("to view error report for failed records with failure reasons.")}</p>
        {this.state.expanded &&
        <div
          className="pre-scrollable notification-error-content">{this.getContent()}</div>
        }
      </div>
    )
  },

  getContent(){
    var {error} = this.props;
    var content = [];
    if (_.isArray(error)) {
      content = _.concat(_.map(error, this.parseErrorContent));
    } else {
      content = this.parseErrorContent(error, 'message');
    }
    return content;
  },

  toggle(){
    var {expanded} = this.state;
    this.setState({expanded: !expanded});
  }
});

ErrorData = withErrors(ErrorData);


module.exports = function (notificationData, t) {
  var itemOptions = _.assign({}, options);

  itemOptions.content = (
    <Notification t={t} type="error" title={t("Upload learners")}>
      <ErrorData t={t} error={notificationData.error}/>
    </Notification>
  );

  return itemOptions;
};
